export default __webpack_public_path__ + "static/media/Beard_5_C5.8ff94e9e.svg";